// 1. IMPORTS
import React from "react";
import { Form, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import PaymentMethodConfigPanel from "./PaymentMethodConfigPanel";
import PaymentMethodBankQrPreview from "./PaymentMethodBankQrPreview";
import { banks } from "constants/bank";
import { PAYMENT_METHOD_TYPE } from "constants/paymentMethod";
import { trimAndUpperCase } from "helper/UtilsFunctionsString";
import { DIGITS_PATTERN } from "helper/UtilsFunctionsValidation";
import { buildVietQRUrl } from "helper/vietqr";

// 2. COMPONENT
function PaymentMethodConfigPanelATMBank(props) {
  const { t: translation } = useTranslation();

  // 4. EVENT HANDLERS
  const prepareValues = (values) => {
    const paymentMethodCode = trimAndUpperCase(values.paymentMethodCode);
    const selectedBank = banks.find((bank) => bank.code === paymentMethodCode);
    const qrUrl = buildVietQRUrl({
      bank: paymentMethodCode,
      account: values.paymentMethodIdentityNumber,
      accountName: values.paymentMethodReceiverName,
    });
    return {
      ...values,
      paymentMethodCode,
      paymentMethodReferName: selectedBank?.name,
      paymentMethodQrCodeUrl: qrUrl,
    };
  };

  // 8. MAIN JSX
  return (
    <PaymentMethodConfigPanel
      {...props}
      paymentMethodType={PAYMENT_METHOD_TYPE.ATM_BANK}
      prepareValues={prepareValues}
      includeQrCode={false}
    >
      <Form.Item
        label={translation("paymentMethod.atmBank.bankLabel")}
        name="paymentMethodCode"
        rules={[{ required: true, message: translation("paymentMethod.atmBank.bankPlaceholder") }]}
      >
        <Select
          showSearch
          placeholder={translation("paymentMethod.atmBank.bankPlaceholder")}
          optionFilterProp="children"
        >
          {banks.map((bank) => (
            <Select.Option value={bank.code} key={bank.code}>
              {bank.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={translation("paymentMethod.atmBank.accountNumberLabel")}
        name="paymentMethodIdentityNumber"
        rules={[
          { required: true, message: translation("paymentMethod.atmBank.accountNumberPlaceholder") },
          { pattern: DIGITS_PATTERN, message: translation("paymentMethod.atmBank.onlyNumbers") },
        ]}
      >
        <Input placeholder={translation("paymentMethod.atmBank.accountNumberPlaceholder")} />
      </Form.Item>
      <Form.Item
        label={translation("paymentMethod.atmBank.accountNameLabel")}
        name="paymentMethodReceiverName"
        rules={[{ required: true, message: translation("paymentMethod.atmBank.accountNamePlaceholder") }]}
      >
        <Input placeholder={translation("paymentMethod.atmBank.accountNamePlaceholder")} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <PaymentMethodBankQrPreview
            bank={getFieldValue("paymentMethodCode")}
            account={getFieldValue("paymentMethodIdentityNumber")}
            accountName={getFieldValue("paymentMethodReceiverName")}
          />
        )}
      </Form.Item>
    </PaymentMethodConfigPanel>
  );
}

// 9. EXPORTS
export default PaymentMethodConfigPanelATMBank;